module.exports = __webpack_public_path__ + "img/png.00d885cc.svg";